import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "gold" };
const _hoisted_2 = { class: "center" };
const _hoisted_3 = { class: "shield" };
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("img", {
    src: "/images/vmchs_footer_shield.svg",
    alt: "VMCHS Shield"
}, null, -1 /* HOISTED */);
const _hoisted_5 = /*#__PURE__*/ _createStaticVNode("<div class=\"general\"><div><figure><img src=\"/images/location_icon.svg\" alt=\"Location Icon\"></figure><div class=\"info\"><h3>Location:</h3><p>525 Sheridan St,<br>Calexico, CA.<br>92231</p></div></div><div><figure><img src=\"/images/hours_icon.svg\" alt=\"Service Hours Icon\"></figure><div class=\"info\"><h3>Business Hours:</h3><p> Monday to Friday<br>08:15-14:45<br><br><!-- Saturday &amp; Sunday&lt;br /&gt;Closed --></p></div></div><div><figure><img src=\"/images/mail_icon.svg\" alt=\"Contact Email Icon\"></figure><div class=\"info\"><h3>Contact us:</h3><p> Phone: <a href=\"tel:7603573461\">(760) 357-3461</a><br><br> Email: <a href=\"mailto:vmoffice@vmchs.com\">vmoffice@vmchs.com</a></p></div></div></div>", 1);
const _hoisted_6 = { class: "blue" };
const _hoisted_7 = { class: "copy" };
const _hoisted_8 = /*#__PURE__*/ _createStaticVNode("<div class=\"social-networks\"><a href=\"https://www.facebook.com/VincentMemorialHighSchool/\" target=\"_blank\" rel=\"nofollow\"><img src=\"/images/facebook_icon.svg\" alt=\"Facebook\"></a><a href=\"https://www.instagram.com/vincentmemorial/\" target=\"_blank\" rel=\"nofollow\"><img src=\"/images/instagram_icon.svg\" alt=\"Instagram\"></a><a href=\"https://twitter.com/VincentMemorial\" target=\"_blank\" rel=\"nofollow\"><img src=\"/images/twitter_icon.svg\" alt=\"Twitter\"></a></div>", 1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_link = _resolveComponent("router-link");
    return (_openBlock(), _createElementBlock("footer", null, [
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                _createElementVNode("figure", _hoisted_3, [
                    _createVNode(_component_router_link, { to: { name: 'Index' } }, {
                        default: _withCtx(() => [
                            _hoisted_4
                        ]),
                        _: 1 /* STABLE */
                    })
                ]),
                _hoisted_5
            ])
        ]),
        _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createTextVNode(" © " + _toDisplayString(new Date().getFullYear()) + " Vicent Memorial Catholic High School ", 1 /* TEXT */)
            ])
        ])
    ]));
}
